import { createThirdwebClient, defineChain } from "thirdweb";
import { createWallet, walletConnect } from "thirdweb/wallets";
import { BRAND } from "./brand";

export const thirdwebClient = createThirdwebClient({
  clientId: import.meta.env.VITE_CLIENT_ID,
});

export const bscChain = defineChain({
  id: Number(import.meta.env.VITE_BSC_CHAIN_ID || 56),
  rpc: import.meta.env.VITE_RPC_URL_BNB,
});

export const thirdwebWallets = [
  createWallet("io.metamask"),
  walletConnect(),
  createWallet("com.coinbase.wallet"),
];

export const thirdwebAppMetadata = {
  name: BRAND.name,
  url: BRAND.domain,
  description: BRAND.tagline,
  logoUrl: `${BRAND.domain}${BRAND.logoPath}`,
};

export const thirdwebWalletConnectOptions = {
  projectId: import.meta.env.VITE_PROJECT_ID,
};
